module.exports = __webpack_public_path__ + "static/fimg5-3c76f86edde8969b2055c4509e79dc13.svg";